var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddCircle = function SvgAddCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M450-290h60v-160h160v-60H510v-160h-60v160H290v60h160zm30.07 190q-78.84 0-148.21-29.92t-120.68-81.21-81.25-120.63Q100-401.1 100-479.93q0-78.84 29.92-148.21t81.21-120.68 120.63-81.25Q401.1-860 479.93-860q78.84 0 148.21 29.92t120.68 81.21 81.25 120.63Q860-558.9 860-480.07q0 78.84-29.92 148.21t-81.21 120.68-120.63 81.25Q558.9-100 480.07-100m-.07-60q134 0 227-93t93-227-93-227-227-93-227 93-93 227 93 227 227 93m0-320"
  })));
};
export default SvgAddCircle;